import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import DocumentTemplateEditor from './DocumentTemplateEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/documents'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'documents_wrapper',
          meta: {
            permissions: ['administrator'],
          },
          redirect: to => {
            return { name: 'documents_settings_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'documents_settings_list',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: 'new',
          name: 'documents_settings_new',
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
          component: DocumentTemplateEditor,
        },
        {
          path: ':templateId/edit',
          name: 'documents_settings_edit',
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
          component: DocumentTemplateEditor,
        },
      ],
    },
  ],
};
